<template>
  <div
      v-if="mapColorizerCategories"
      class="d-flex flex-column rounded-1 bg-theme-transparent gmb-block--floating-box"
  >
    <GmbSection
        :childControlGroupId="controlGroupId"
        :childControlKeywordObjs="mapColorizerKeywordObjs"
        :childRadioButtonActivatedValue="activatedMapColorizerSlug"
        :childRadioButtonAllValues="allMapColorizerSlugs"
        disableSearch
        :displayLevel="1"
        lockHeader
        isCollapsible
        title="Coloriser par"
        @child-radio-button-value-changed="
        (newActivatedMapColorizerSlug) =>
          $emit('activated-map-colorizer-changed', newActivatedMapColorizerSlug)
      "
    >
      <template #picto>
        <FdText colorTheme4 fa>
          <i class="fas fa-map-marker-alt"/>
        </FdText>
      </template>

      <template #infoSticker>
        <GmbSticker :text="mapColorizerCount"/>
      </template>

      <!-- <GmbRow
        v-for="(mapColorizer, i) in mapColorizerCategories[0].mapColorizers"
        :controlGroupId="controlGroupId"
        :controlValue="mapColorizer.identifier"
        isRadioButton
        :key="'flat-' + i"
      >
        <FdText tag="span">{{ mapColorizer.label }}</FdText>

        <template #infoSticker>
          <GmbSticker :text="Object.keys(mapColorizer.colorMapper).length" />
        </template>
      </GmbRow> -->

      <!-- <template v-for="(mapColorizerGroup, i) in mapColorizerCategories.slice(1)"> -->
      <template v-for="(mapColorizerGroup, i) in mapColorizerCategories">
        <GmbSection
            v-if="mapColorizerGroup.mapColorizers.length"
            class="mt-2"
            :displayLevel="2"
            :key="'nested-' + i"
            :title="mapColorizerGroup.label"
        >
          <GmbRow
              v-for="(mapColorizer, i) in mapColorizerGroup.mapColorizers"
              class="mt-2"
              :controlGroupId="controlGroupId"
              :controlValue="mapColorizer.identifier"
              isRadioButton
              :key="i"
          >
            <FdText tag="span">{{ mapColorizer.label }}</FdText>

            <template #infoSticker>
              <GmbSticker tag="span">{{
                  Object.keys(mapColorizer.colorMapper).length
                }}
              </GmbSticker>
            </template>
          </GmbRow>
        </GmbSection>
      </template>
    </GmbSection>
  </div>
</template>

<script>
import {convertAsKeywords, getUniqueId} from "@/helpers";

import FdText from "@/flexdesign/Text";

import GmbRow from "@/widgets/Row";
import GmbSection from "@/widgets/Section";
import GmbSticker from "@/widgets/Sticker";

export default {
  name: "MapColorizers",

  components: {
    FdText,
    GmbRow,
    GmbSection,
    GmbSticker,
  },

  props: {
    activatedMapColorizerSlug: String,
    allMapColorizerSlugs: Array,
    mapColorizerCategories: Array,
  },

  data() {
    return {};
  },

  computed: {
    controlGroupId() {
      return getUniqueId();
    },

    mapColorizerCount() {
      return this.mapColorizerCategories.reduce(
          (currentCount, mapColorizerCategory) => currentCount + mapColorizerCategory.mapColorizers.length,
          0
      );
    },

    mapColorizerKeywordObjs() {
      let keywordObjs = [];

      this.mapColorizerCategories.forEach((mapColorizerCategory) => {
        mapColorizerCategory.mapColorizers.forEach((mapColorizer) => {
          keywordObjs.push({
            value: mapColorizer.identifier,
            keywords: convertAsKeywords(mapColorizer.label),
          });
        });
      });

      return keywordObjs;
    },
  },

  watch: {},

  beforeCreate() {
  },

  created() {
  },

  beforeMount() {
  },

  mounted() {
  },

  beforeUpdate() {
  },

  updated() {
  },

  beforeUnmount() {
  },

  unmounted() {
  },

  methods: {},
};
</script>

<style lang="scss"></style>
